// **************************************************************************
// CONTRACT MANAGEMENT STATE
// Admin-specific state for contract CRUD operations
// Note: Contract list data is in entities/contract/contracts
// **************************************************************************

export interface ContractManagementState {
    creating: boolean;
    deleting: boolean;
}

export const initialContractManagementState: ContractManagementState = {
    creating: false,
    deleting: false,
};
